import { useTranslations } from "next-intl";
import { Navigate } from "react-router-dom";
import { useSearchParams } from "@/hooks/useSearchParams";
import { SCard } from "@/components/Card/SCard";
import { Spacing } from "@/components/Spacing/Spacing";
import { AuthLayout } from "./AuthLayout";
import { CompleteSignupContent } from "./complete-signup/CompleteSignupContent";

export function CompleteSignupPage() {
  const t = useTranslations("register");
  const search = useSearchParams();
  const token = search.get("token");

  if (!token) return <Navigate to="/auth/register" replace />;

  return (
    <AuthLayout>
      <SCard
        width="w-[95vw] sm:max-w-150"
        header={t("completeSignupTitle")}
        outline="outline-quaternary"
        shadow="shadow-xl"
      >
        <Spacing height="h-6" />
        <CompleteSignupContent token={token} />
      </SCard>
    </AuthLayout>
  );
}
